module.exports = __webpack_public_path__ + "img/btn-start.d75e0e9b.png";